import React, { Component } from 'react';
import DialogInput from './DialogInput';
import Pagination from '../basic/Pagination';
import CheckinPatient from '../basic/CheckinPatient';
import { connect } from 'react-redux';
import { getCheckIn, removeCheckIn, checkinSearch, saveOrder, addToCheckIn, cleanAddCheckIn, getCheckInById } from 'actions/EntityActions';
import { handleCheckInDialog, showSnackbar } from 'actions/CommonActions';
import { Button } from '@mui/material';
import TextInput from '../basic/TextInput';
import CustomButton from '../basic/Button';
import GenericTable from './GenericTable';
import { Link } from 'react-router-dom';
import WithRouter from '../../../custom/withRouter';
import DialogHeaderWithClose from '../basic/DialogHeaderWithClose';


const statusList = 'LIST';

class CheckinDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isAdditionalInformationOpen: false,
            additionalInformation: null,
            status: statusList || 'None',
            activePage: 1,
            activePageSearchResult: 1,
            itemsPerPage: 10,
            checkinList: {},
            checkinSearchList: [],
            showSearchResult: false,
            orderBy: 'DESC',
            sortBy: 'Id',
        };
    }

    componentWillMount() {
        this.getCheckIn();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.checkinList !== undefined && newProps.checkinList !== this.props.checkinList) {
            this.setState({ checkinList: newProps.checkinList });
        }

        if (newProps.checkinSearchList !== undefined && newProps.checkinSearchList !== this.props.checkinSearchList) {
            this.setState({ checkinSearchList: newProps.checkinSearchList });
        }

        if (!this.props.posOrder && newProps.posOrder) {
            this.redirectPOS(newProps.posOrder.id);
            if (newProps.posOrder.status === 'Completed' || newProps.posOrder.status == 2) {
                this.setState({ cashDrawerOpenWhenOrderCompleted: true });
            }
        }
        //ADD
        if ((newProps.checkInSuccess != undefined && newProps.checkInSuccess !== this.props.checkInSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.checkInSuccess) {
                this.saveSuccess("ADD");
            }
            else {
                this.saveFailure("ADD");
            }
        }
        //DELETE
        if ((newProps.removeCheckInSuccess != undefined && newProps.removeCheckInSuccess !== this.props.removeCheckInSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.removeCheckInSuccess) {
                this.saveSuccess("DELETE");
            }
            else {
                this.saveFailure("DELETE");
            }
        }

        if (newProps.checkInMember !== undefined && newProps.checkInMember !== this.props.checkInMember) {
            if (newProps.checkInMember.success) {
                this.startOrder(newProps.checkInMember.id)
            }
            else {
                this.saveFailure("START");
            }
        }
    }

    getCheckIn = () => {
        this.props.getCheckIn({ page: this.state.activePage, itemsPerPage: this.state.itemsPerPage });
    }

    pageChange = (page) => {
        this.setState({
            activePage: page
        }, () => this.getCheckIn());

    }

    handleClose = () => {
        this.props.handleCheckInDialog();
    }

    removeCheckIn = (id) => {
        this.props.removeCheckIn(id);
    }

    startOrder = (id) => {
        const orderModel = this.selectOrderModel(id);
        this.props.saveOrder(orderModel);
        this.removeCheckIn(id);
        this.handleClose();
    }

    redirectPOS = (posId) => {
        this.props.navigate(`/pos/${posId}`);
    }

    addToCheckIn = (id) => {
        this.props.addToCheckIn(id)

        this.setState({ showSearchResult: false })
    }

    checkinSearch = () => {
        this.props.checkinSearch({
            page: this.state.activePageSearchResult,
            itemsPerPage: 5,
            firstName: this.props.checkInFirstName ? this.props.checkInFirstName : "",
            lastName: this.props.checkInLastName ? this.props.checkInLastName : "",
            cardNumber: this.props.cardNumberFilter ? this.props.cardNumberFilter : "",
            id: this.props.checkInPatientId ? this.props.checkInPatientId : 0,
            status: "None",
            careGiver: "",
            phone: this.props.checkInPhone ? this.props.checkInPhone : "",
            email: "",
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
        });

        this.setState({ showSearchResult: true })
    }

    mapCheckinSearch = (checkinSearchList) => {
        return checkinSearchList.map((item) => {
            return {
                Id: item.id,
                Name: item.firstName + " " + item.lastName,
                Phone: item.phone,
                AddToList: (
                    <Link onClick={() => this.addToCheckIn(item.id)}>
                        <span className="text-info fw_bold">Check In</span>
                    </Link>
                )
            }
        })
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePageSearchResult: 1
            };
        }, this.checkinSearch);
    }

    pageChangeSearchResult = (page) => {
        this.setState({
            activePageSearchResult: page
        }, () => this.checkinSearch());
    }

    //when data is saved successfully
    saveSuccess = (type) => {
        if (type == "ADD") {
            this.props.showSuccess("Patient added successfully to Check-in list");
        } else if (type == "DELETE") {
            this.props.showSuccess("Patient was deleted successfully");
        } else {
            this.props.showSuccess("Patient added to order successfully");
        }

        this.getCheckIn();
    }

    getMemberCheckIn = (id) => {
        this.props.getMemberCheckIn(id);
    }

    //when data is not saved, failure
    saveFailure = (type) => {
        this.props.cleanAddCheckIn();
        if (type == "ADD") {
            this.props.showSuccess("Member doesn't exist or is already in the Check-in list");
        } else {
            this.props.showSuccess("Member is not longer in the list");
        }

        this.getCheckIn();
    }

    selectOrderModel = (patient, newProduct) => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const posOrderModel = this.props.posOrder;
        const productsModel = posOrderModel ? posOrderModel.products || [] : [];
        const branchId = this.props.branchId;
        const employeeId = this.props.userPin.authenticated ? this.props.userPin.employee.id : 0;

        let products = productsModel ? productsModel.map((item) => {
            return {
                id: item.id,
                productId: item.productId,
                quantity: item.quantity,
                branchId: branchId
            };
        }) : [];

        if (newProduct) {
            products.push(newProduct);
        }

        const order = {
            id: posOrderModel ? posOrderModel.id : 0,
            patientId: patient ? patient : posOrderModel ? posOrderModel.patientId : 0,
            deviceId: deviceData.id,
            employeeId: employeeId,
            products: products,
            branchId: branchId
        };

        return order;
    }

    render() {
        let actions = [

            <Button key="dialogAlertClose" variant="text" onTouchTap={this.handleClose} color="primary">Close</Button>
        ];
        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text="Check-In List" classicClass="posDialogClassic" handleClose={() => this.handleClose()} />}
                    className="checkIn_list"
                    open={this.props.open}
                    autoScrollBodyContent={true}
                    actions={actions}
                >
                    <div className="row m-0 mb-4">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                            <TextInput
                                type="number"
                                name={`CheckInPatientId`}
                                className="search-field"
                                label={"Member Id"}
                                floatingLabelText={"Member Id"}
                                hintText={"Member Id"}
                                maxLength={20}
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                            <TextInput
                                name={`CheckInFirstName`}
                                className="search-field"
                                label={"First Name"}
                                floatingLabelText={"First Name"}
                                hintText={"First Name"}
                                maxLength={20}
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                            <TextInput
                                name={`CheckInLastName`}
                                className="search-field"
                                label={"Last Name"}
                                floatingLabelText={"Last Name"}
                                hintText={"Last Name"}
                                maxLength={20}
                            />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                            <TextInput
                                type="number"
                                name={`CheckInPhone`}
                                className="search-field"
                                label={"Phone"}
                                floatingLabelText={"Phone"}
                                hintText={"Phone"}
                                maxLength={20}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 pt-4">
                            <CustomButton
                                type="IconSearchButton"
                                className="pull-right btnNewBrandPOS"
                                label={"Search"}
                                onTouchTap={() => this.search()}
                            />
                        </div>
                    </div>

                    {
                        this.state.showSearchResult &&
                        <div className="form-group">
                            <h4>Search result:</h4>
                            <GenericTable
                                className="table_center tableHeaderwhiteColorFont"
                                tableBodyClassName="patients-table"
                                columns={
                                    [
                                        { key: "Id", label: "Id" },
                                        { key: "Name", label: "Name" },
                                        { key: "Phone", label: "Phone" },
                                        { key: "AddToList", label: "Add to List" }
                                    ]
                                }
                                rows={this.mapCheckinSearch(this.state.checkinSearchList)}
                                stripedRows={true}
                            />

                            <Pagination
                                length={(this.props.checkinSearchLength || 0)}
                                itemsPerPage={5}
                                activePage={this.state.activePageSearchResult}
                                onPageChange={(e) => this.pageChangeSearchResult(e)}
                                maxButtons={4} />
                        </div>
                    }


                    {
                        this.state.checkinList.total == 0
                            ?
                            "Check-in List is Empty"
                            :
                            (this.state.checkinList.list || []).map((item, index) => (
                                <CheckinPatient
                                    key={index}
                                    index={index + 1}
                                    page={this.state.activePage}
                                    patient={item}
                                    remove={this.removeCheckIn}
                                    pos={this.getMemberCheckIn}
                                />
                            ))
                    }

                    <Pagination
                        length={(this.state.checkinList ? this.state.checkinList.total : 0)}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        onPageChange={(e) => this.pageChange(e)}
                        maxButtons={4} />

                </DialogInput>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        checkinList: state.entity.checkinList,
        checkInDialog: state.common.checkInDialog,
        userPin: JSON.parse(sessionStorage.getItem('pinUser')) ? JSON.parse(sessionStorage.getItem('pinUser')) : state.entity.pin,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        posOrder: state.entity.posOrder,
        checkInPatientId: state.form.CheckInPatientId,
        checkInFirstName: state.form.CheckInFirstName,
        checkInLastName: state.form.CheckInLastName,
        checkInPhone: state.form.CheckInPhone,
        checkInSuccess: state.entity.addCheckIn,
        removeCheckInSuccess: state.entity.removeCheckIn,
        checkInMember: state.entity.checkInMember,
        checkinSearchList: state.entity.checkinSearchList,
        checkinSearchLength: state.entity.checkinSearchLength,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        checkinSearch: (model) => dispatch(checkinSearch(model)),
        getCheckIn: model => dispatch(getCheckIn(model)),
        handleCheckInDialog: () => dispatch(handleCheckInDialog()),
        removeCheckIn: (id) => dispatch(removeCheckIn(id)),
        saveOrder: (order) => dispatch(saveOrder(order)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        addToCheckIn: (id) => dispatch(addToCheckIn(id)),
        getMemberCheckIn: (id) => dispatch(getCheckInById(id)),
        cleanAddCheckIn: () => dispatch(cleanAddCheckIn())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CheckinDialog));
